<template>
    <ul class="stock-list">
        <li v-for="(item, index) in stockList"
            :key="index"
            @click="checkoutList(index)"
            :class="index===activeIndex?'item-active':''"
        >{{item}}</li>
    </ul>
</template>

<script>
import event from '../event'
export default {
    data() {
        return {
            stockList: ['自选陆股通', '沪股通成交榜', '深股通成交榜', '港股通(沪)成交榜', '港股通(深)成交榜'],
            activeIndex: 1
        }
    },
    methods: {
        checkoutList(index) {
            this.activeIndex = index
            event.set('stockListSelected', this.activeIndex)
            // 埋点
            window.TA.log({
                id: `webhsgt_stocklist_click_${index + 1}`
            })
        }
    }
}
</script>

<style lang="less">
.stock-list {
    height: 112px;
    font-size: 12px;
    // padding-top: 14px;
    li {
        height: 33px;
        line-height: 33px;
        color: #959595;
        padding-left: 23px;
        &.item-active {
            color: #fff;
        }
        &:hover {
            cursor: pointer;
            background: #343434;
        }
    }
}

.newblack{
    .stock-list{
        li{
            color: #272841;
            &.item-active {
                color: #1b63d9;
            }
            &:hover {
                background: none;
            }
        }
    }
}
.newgrey{
    .stock-list{
        li{
            color: #fff;
            &.item-active {
                color: #1b63d9;
            }
            &:hover {
                background: none;
            }
        }
    }
}
.newclassic{
    .stock-list{
        li{
            color: #fff;
            &.item-active {
                color: #e63030;
            }
            &:hover {
                background: none;
            }
        }
    }
}
</style>
